import { render, staticRenderFns } from "./ParentCertificate.vue?vue&type=template&id=060feaf3&scoped=true"
import script from "./ParentCertificate.vue?vue&type=script&lang=js"
export * from "./ParentCertificate.vue?vue&type=script&lang=js"
import style0 from "./ParentCertificate.vue?vue&type=style&index=0&id=060feaf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060feaf3",
  null
  
)

export default component.exports